import { render, staticRenderFns } from "./TechnicalService.vue?vue&type=template&id=182197d8&scoped=true"
import script from "./TechnicalService.vue?vue&type=script&lang=js"
export * from "./TechnicalService.vue?vue&type=script&lang=js"
import style0 from "./TechnicalService.vue?vue&type=style&index=0&id=182197d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_dshyztwqotzq6hkhxg56wcmkza/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182197d8",
  null
  
)

export default component.exports